// The signed-in-as avatar renders the user's own AvatarURL on top of a
// server-rendered initials badge. If the image fails to load (the identity
// provider's CDN is unreachable, the URL has gone stale), drop it so the
// initials underneath show through.

export function initAvatarFallback(root = document) {
  root.querySelectorAll('img[data-avatar-img]').forEach((img) => {
    // The script is deferred, so an image that failed fast may have dispatched its
    // `error` before this listener existed - leaving a broken-image glyph sitting on
    // top of the initials with nothing left to fire. A finished load (`complete`) that
    // decoded nothing (`naturalWidth === 0`) is exactly that case, so sweep it here too.
    if (img.complete && img.naturalWidth === 0) {
      img.remove()
      return
    }
    img.addEventListener('error', () => img.remove())
  })
}
